import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=24a2fc0e"
import script from "./FilePreview.vue?vue&type=script&lang=ts"
export * from "./FilePreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports